import React from 'react'
import RadioGroup from 'components/forms/radio-group'
import Radio from 'components/forms/radio'
import {
  REG_ITEM_RESERVATION_STATUS_AVAILABLE,
  REG_ITEM_RESERVATION_STATUS_RESERVED,
} from '../../actions/reg-items-actions'

const ReservationFilter = ({
  addFilter,
  className,
  decorator,
  label,
  selected,
}) => (
  <React.Fragment>
    {label && (
      <React.Fragment>
        <hr className="mbl" />
        <div className="h6 text-uppercase text-bold text-light tiny mtn mbs">
          {label}
        </div>
      </React.Fragment>
    )}

    {decorator(
      <RadioGroup className={className}>
        <Radio
          name="gift-view"
          tappable
          label="All Gifts"
          defaultChecked={!selected}
          onChange={() => addFilter({ giftView: null })}
        />

        <Radio
          name="gift-view"
          tappable
          label="Available Gifts"
          defaultChecked={selected === REG_ITEM_RESERVATION_STATUS_AVAILABLE}
          onChange={() =>
            addFilter({ giftView: REG_ITEM_RESERVATION_STATUS_AVAILABLE })
          }
        />

        <Radio
          name="gift-view"
          tappable
          label="Reserved &amp; Purchased Gifts"
          defaultChecked={selected === REG_ITEM_RESERVATION_STATUS_RESERVED}
          onChange={() =>
            addFilter({ giftView: REG_ITEM_RESERVATION_STATUS_RESERVED })
          }
        />
      </RadioGroup>
    )}
  </React.Fragment>
)

ReservationFilter.defaultProps = {
  decorator: (component) => component,
}

export default ReservationFilter
